"use client"
import React, { Fragment, useState, useEffect } from "react";
import { useAppData } from "@/lib/providers/AppDataProvider";

import "@/components/shared/PlaceTypeLabel.css";

const PlaceTypeLabel = ({ values, multiple, as, className, icon = false }) => {
  const { flattenedProfileTypes: profileTypes } = useAppData();
  const [entries, setEntries] = useState(null);

  useEffect(() => {
    if (values && values.length > 0 && profileTypes.length > 0) {
      var newEntries = [];
      values.forEach((value, index) => {
        var entry = profileTypes.find(pt => pt.value === value);
        if (entry) {
          newEntries.push(entry);
        }
      });
      setEntries(newEntries);
    }
  }, [values, profileTypes]);

  if (!entries) return <></>;
  else {
    if (entries.length > 0) {
      if (multiple) {
        return (
          <>
            {as === "span" ? (
              <span className={className ?? ""}>
                {entries.map((entry, index) => {
                  return <span key={index} className="label">{entry.label}</span>;
                })}
              </span>
            ) : (
              <div className={className ?? "profile-type-label-container"}>
                {entries.map((entry, index) => {
                  return (
                    <Fragment key={index}>
                      {icon && entry.icon ? (
                        <div className="with-icon">
                          <span className="material-icons">{entry.icon}</span>
                          <span className="label">{entry.label}</span>
                        </div>
                      ) : (
                        <span className="label">{entry.label}</span>
                      )}
                    </Fragment>
                  );
                })}
              </div>
            )}
          </>
        );
      } else {
        return (
          <>
            {as === "span" ? (
              <span>{entries[0].label}</span>
            ) : (
              <div className={className ?? "profile-type-label-container"}>
                {icon && entries[0].icon ? (
                  <div className="with-icon">
                    <i className={`fa-light fa-${entries[0].icon}`}></i>
                    <span className="label">{entries[0].label}</span>
                  </div>
                ) : (
                  <span className="label">{entries[0].label}</span>
                )}
              </div>
            )}
          </>
        );
      }
    } else {
      return <></>;
    }
  }
};
export default PlaceTypeLabel;
